<template>
  <center
    style="padding-left: 50px;padding-right:50px; padding-top:10px;padding-bottom:10px;"    
  >
    <v-btn
      v-if="!isTotem && url"
      block
      style="height: 50px;"
      :color="BGColorSecundary"
      :style="{ 'color': ColorSecundary}" 
      dark
      :href="url.URL"
      target="_blank"
    >
      {{ text }}
    </v-btn>
    <!--v-btn
      v-if="isTotem"
      block
      style="height: 50px;"
      :color="BGColorSecundary"
      :style="{ 'color': ColorSecundary}" 
      dark
      @click="handleGoTo"
    >
      {{ text }}
    </v-btn>
    <external-link
      v-if="externalLink"
      :item="externalLink"
      :locale="locale"
      :showDialog="showExternalLink"
      :onClose="handleCloseExternalLink"
      :bgColor="BGColor"
    /-->
  </center>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import axios from 'axios'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import ExternalLink from '../../../totem/totemMainMenu/ExternalLink'
  export default {
    components: {
      ExternalLink,
    },
    props: {
      content: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      showExternalLink: false,
      externalLink: null,
      url: null,
    }),
    computed: {
      ...mapState('app',['BGColor', 'locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColorSecundary', 'ColorSecundary']),
      text () {
        return 'ir'//this.data.LinkExternalName ? utils.getTranslation (this.data.LinkExternalName, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      isTotem () {
        return this.$route.path.indexOf('/totem') >= 0 || utils.isTotem()
      },
      domain () {
        return utils.getDomain()
      },
    },
    mounted () {
      this.prepareURL()
    },
    methods: {
      async prepareURL () {
        try {
          const c = this.$session.get('charResponse')
          if (!c || !c.Ident) {
            alert('Requiere login.')
            return
          }
          this.url = await new Promise((resolve, reject) => axios.post(utils.getAPIURL('utils/char', false, this.domain.concat('/link-room')), { Identifier: c.Ident })
            .then(response => {
              resolve(response.data)
            })
            .catch(error => {
              console.log('error', error)
              resove(null)
            }))
        } catch (error) {
          console.log(error)
        }
      },
      handleCloseExternalLink () {
        this.showExternalLink = false
      },
      async handleGoTo () {
        try {
          const c = this.$session.get('charResponse')
          if (!c || !c.Ident) {
            alert('Requiere login.')
            return
          }
          const body = {
          }

          const linkRoom = await new Promise((resolve, reject) => axios.post(utils.getAPIURL('utils/char', false, this.domain.concat('/link-room')), { Identifier: c.Ident })
            .then(response => {
              resolve(response.data)
            })
            .catch(error => {
              console.log('error', error)
              resove(null)
            }))
          if (!linkRoom || !linkRoom.URL) {
            alert('Habitación no encontrada.')
            return
          }

          if (this.isTotem) {
            this.externalLink = {
              externalLink: {es: linkRoom.URL}
            }
            this.showExternalLink = true
          } else if (!this.isSimulation) {
            let  url = linkRoom.URL

            // ini showroom
            const actualUrl = window.location.href
            if (actualUrl.indexOf('?') < 0) url += '?'
            if (actualUrl.indexOf('fm=true') > 0) url += '&fm=true'
            if (actualUrl.indexOf('fl=true') > 0) url += '&fl=true'
            // end showroom
            if (url)
              window.open(
                url,
                '_blank' // <- This is what makes it open in a new window.
              )
            else window.location.href = url
          }   
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
